
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          top
          v-if="$utilFront.withPermission($prm.MODULE_COLPOSCOPY_ATTEND)"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="get(item.idMedicalPractice, 2)">
              <v-icon color="secondary" v-bind="attrs" v-on="on">
                mdi-doctor
              </v-icon>
            </v-btn>
          </template>
          <span>Atender</span>
        </v-tooltip>
        <v-tooltip
          top
          v-if="$utilFront.withPermission($prm.MODULE_COLPOSCOPY_CANCEL)"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="checkCancel(item)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-stop
              </v-icon>
            </v-btn>
          </template>
          <span>Cancelar</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.startTime`]="{ item }">
        {{ $utilFront.formatDateTime(item.startTime) }}
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogCancelation"
      v-if="dialogCancelation"
      persistent
      max-width="70%"
    >
      <cancelation-modal
        ref="cancelationModal"
        :dataModal="dataModal"
        @closeCancelationDialog="closeCancelationDialog"
        :dialogCancelation="dialogCancelation"
      />
    </v-dialog>
  </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";

export default {
  name: "ColposcopyPendingTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    updateStatus: Function,
    itemsPerPage: Number,
  },
  components: {
    MenuCrud,
    CancelationModal,
  },
  data() {
    return {
      idPatient: null,
      appointmentDialog: false,
      dataModal: {},
      dialogCancelation: false,
      headers: [
        {
          text: "Id Consulta",
          value: "idMedicalPractice",
          sortable: false,
          align: "center",
          width: "20%",
        },
        {
          text: "Id Paciente",
          value: "idPatient",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "Nombre del paciente",
          value: "fullName",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha y hora de solicitud",
          value: "startTime",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
    };
  },
  methods: {
    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeCancelationDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
  },
};
</script>
